module.exports = __webpack_public_path__ + "static/img/spoon.2962b3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/spoon.png
// module id = ZjoX
// module chunks = 0